import React from 'react'
import { useSelector } from 'react-redux'
import './_checkMethodPayment.scss'
import { ReactComponent as Euro } from '../../assets/new-icons/addPay.svg';
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from 'react-router-dom';

function CheckMethodPayment() {
    const navigate = useNavigate()
    const iban = useSelector((user) => user.user.datiPagamento.account_iban)
    const token = useSelector((user) => user.user.datiPagamento.token)
    const section = useSelector((user) => user.settings.section)
    const ibanGas = useSelector((user) => user.gas?.datiPagamento?.account_iban)
    const tokenGas = useSelector((user) => user.gas?.datiPagamento?.token)
    return (
        section === false && iban === null && token === null ||
        section && ibanGas === null  && tokenGas === null ? (
            <div className='checkMethod boxInfo'>
                <div className="checkMethod-iconWrap">
                    <div className="checkMethod-iconWrap_icon">
                        <Euro />
                    </div>
                </div>
                <div className="checkMethod-text">
                    <p className="checkMethod-text_title">
                        Semplifica i tuoi pagamenti
                    </p>
                    <p className='checkMethod-text_description'>Aggiungi subito un metodo per pagare in maniera rapida e sicura.</p>
                </div>
                <div className="checkMethod-button" onClick={() => section ? navigate('/enrica/gas/cambio-metodo') : navigate('/enrica/cambio-metodo')}>
                    <p className="checkMethod-button_label">
                        Aggiungi metodo
                    </p>
                    <ArrowForwardIos />
                </div>
            </div>
        ) : (
            <div className='checkMethod'>
                <div className="checkMethod-iconWrap">
                    <div className="checkMethod-iconWrap_icon">
                        <Euro />
                    </div>
                </div>
                <div className="checkMethod-text">
                    <p className="checkMethod-text_title">
                        Semplifica i tuoi pagamenti
                    </p>
                    <p className='checkMethod-text_description'>Aggiungi o modifica subito un metodo per pagare in maniera rapida e sicura.</p>
                </div>
                <div className="checkMethod-button" onClick={() => section ? navigate('/enrica/gas/cambio-metodo') : navigate('/enrica/cambio-metodo')}>
                    <p className="checkMethod-button_label">
                        Aggiungi o modifica metodo
                    </p>
                    <ArrowForwardIos />
                </div>
            </div>
        )
    )
}

export default CheckMethodPayment